// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"70bc088a89379b26157d","293":"7f5cf149d50b26eb8cc3","522":"e9fb79faa67234c9ad5b"}[chunkId] + ".js";
};